import styled from "styled-components";
import { colorsPalettes, rgba } from "@similarweb/styles";

export const WidgetWrapper = styled.div`
    width: 50%;
    height: 320px;
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0px 3px 6px ${rgba(colorsPalettes.carbon[500], 0.08)};
    border-radius: 4px;
`;

export const DomainsTableWrapper = styled.div`
    padding: 0 8px 0 8px;
`;
